import { useEffect } from 'react';
import { EmojiDizzy } from 'react-bootstrap-icons';
import { Navigate, useParams } from 'react-router-dom';

import { Button, Spin, Typography } from 'antd';

import EmptyState from '@/components/shared/EmptyState';
import { useAppSelector } from '@/hooks/redux';
import { enCourseType } from '@/interfaces/course';
import { useAcceptInviteMutation } from '@/services/invites';
import { logout } from '@/services/token';
import styled from '@/styled';

const Invite = () => {
  const { inviteId } = useParams();

  const [acceptedInvite, { error, isLoading, isUninitialized, data }] = useAcceptInviteMutation();
  const user = useAppSelector(state => state.auth.user);

  useEffect(() => {
    acceptedInvite(inviteId);
  }, [inviteId, acceptedInvite]);

  if (isLoading || isUninitialized) {
    return <EmptyState icon={<Spin size='large' />} title='Validando convite' description={undefined} />;
  }

  if (error && (error as any)?.status === 403) {
    return (
      <EmptyState
        icon={<EmojiDizzy />}
        title='Esse convite não pertence ao usuário que você está logado.'
        description={
          <>
            <Typography>{user?.email}</Typography>
            <Typography>Por favor troque de usuário e tente novamente.</Typography>
            <Button size='large' className='buttonChangeUserInvite' type='primary' onClick={() => logout()}>
              Trocar de usuário
            </Button>
          </>
        }
      />
    );
  } else if (error && (error as any)?.status === 404) {
    return <Navigate to='/resumo' />;
  } else if (error) {
    return (
      <EmptyState
        icon={<EmojiDizzy />}
        title='Ops. Parece que houve algum erro ao tentar ativar o convite.'
        description={<Typography>Por favor tente novamente.</Typography>}
      />
    );
  }

  if (data?.type === enCourseType.package) {
    return <Navigate to={`/pacote/${data.hash}`} state={{ packageTitle: `Pacote ${data.title}` }} />;
  }

  if (data?.type === enCourseType.course) {
    return <Navigate to={`/curso/${data.hash}`} />;
  }

  return <Navigate to='/cursos' />;
};

export default styled(Invite)`
  .buttonChangeUserInvite {
    margin-top: '10px';
  }
`;
